







import Vue from 'vue'
import Component from 'vue-class-component'


@Component({
  components: {}
})
class ProductResourceItem2ProductComments extends Vue {

}

export default ProductResourceItem2ProductComments


